<script lang="ts">
  import { cn } from '$lib/utils';

  let { class: className = '' }: { class?: string } = $props();
</script>

<div class={cn('qs-skeleton qs-pulse rounded-md bg-muted', className)}></div>
